import { Box, Stack, TableCell, TableRow, Typography } from '@mui/material';

export const RecentActivityStatus = () => {
  return (
    <TableRow>
      <TableCell
        colSpan={5}
        sx={{
          borderBottom: 'none',
          backgroundColor: '#F9F9FA',
        }}
      >
        <Box
          sx={{
            height: 'calc(100vh - 497px)',
            display: 'grid',
            placeItems: 'center',
          }}
        >
          <Stack alignItems="center" spacing={2}>
            <Stack alignItems="center">
              <Typography fontSize={13} color="#202227">
                No Recent Activity.
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </TableCell>
    </TableRow>
  );
};
